//React
import React from 'react'
import classNames from 'classnames'
//Styles
import useStyles from './CustomItemInformation.styles'
//Hooks
import { useTexts } from '../../hooks'
//Interfaces
import { ICustomItemInformation } from '../../types'
import ImagePlaceholder from '../../../../image-placeholder/ImagePlaceholder'

const CustomItemInformation: React.FC<ICustomItemInformation> = ({
  itemName,
  itemImage,
  isProduct,
}) => {
  const classes = useStyles()
  const { toppingTitle } = useTexts()

  return (
    <div className={classNames(classes.itemImageContainer)}>
      {!isProduct && (
        <h5 className={classNames(classes.itemTitle)}>{toppingTitle}</h5>
      )}
      {isProduct && (
        <ImagePlaceholder
          src={itemImage}
          classes={{ img: classes.imageSmall }}
        />
      )}
      <span className={classNames(classes.itemName)}>{itemName}</span>
    </div>
  )
}

CustomItemInformation.defaultProps = {
  itemName: '',
  itemImage: '',
  isProduct: true,
}

export default CustomItemInformation
